import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: `
    <main class="app-shell">
      <router-outlet />
    </main>
  `,
  styles: [
    `
      :host {
        display: block;
        min-height: 100vh;
        background: #ececec;
      }

      .app-shell {
        max-width: 420px;
        min-height: 100vh;
        margin: 0 auto;
        background: #fff;
        box-shadow: 0 0 24px rgba(0, 0, 0, 0.08);
      }
    `,
  ],
})
export class AppComponent {}
